import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map, times, isEmpty } from 'lodash/fp';
import classNames from 'classnames';
import threadLoadingSrc from 'images/thread_loading.svg';
import { postComment } from 'actions/editor/commentary';
import { getFilteredThreads } from 'selectors/commentary';
import LoadableState from 'components/shared/loadable';
import ScrollableContainer from 'components/shared/scrollable';
import CommentForm from './CommentForm';
import Thread from './CommentThread';
import BlankSlate from './BlankSlate';
import ErrorBlankSlate from './ErrorBlankSlate.jsx';
import CommentaryHeader from './CommentaryHeader.jsx';

class Commentary extends Component {
  constructor(props) {
    super(props);
    this.state = { sticky: false };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.handleScroll();
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(e) {
    requestAnimationFrame(() => {
      if (this.container) {
        const { parentNode, clientHeight } = this.container;
        if (
          this.props.editorRef.current &&
          parentNode.offsetTop <= window.pageYOffset &&
          clientHeight < this.props.editorRef.current.clientHeight
        ) {
          this.setState({ sticky: true });
        } else {
          this.setState({ sticky: false });
        }
      }
    });
  }

  renderNewThread() {
    return (
      <div className="Commentary-renderNewThread">
        <CommentForm
          placeholder={t('lessons.editor.collaboration.post_new_comment')}
          buttonText={t('lessons.editor.collaboration.comment')}
          postComment={this.props.postComment}
        />
      </div>
    );
  }

  renderThread(thread) {
    return <Thread {...thread} key={thread.id} />;
  }

  renderThreads() {
    const { fetching, threads } = this.props;
    return (
      <LoadableState loading={fetching}>
        {map(this.renderThread)(threads)}
      </LoadableState>
    );
  }

  renderPlaceholders() {
    const placeholderSrc = threadLoadingSrc;
    const makePreview = i => (
      <div
        key={i}
        className="CommentThread-placeholder"
        style={{ background: `url(${placeholderSrc})` }}
      />
    );
    return times(makePreview, 3);
  }

  render() {
    const { threads, fetching, success } = this.props;
    const containerClassName = classNames('Commentary', {
      sticky: this.state.sticky,
    });

    return (
      <div
        ref={n => {
          this.container = n;
        }}
        className={containerClassName}
      >
        <CommentaryHeader />
        {this.renderNewThread()}
        {!isEmpty(threads) && <div className="Commentary-divider" />}
        <ScrollableContainer maxHeight={null} hidden>
          <div className="Commentary-threads">
            {isEmpty(threads) && fetching && this.renderPlaceholders()}
            {!isEmpty(threads) && this.renderThreads()}
            {success && isEmpty(threads) && !fetching && <BlankSlate />}
            {!success && <ErrorBlankSlate />}
          </div>
        </ScrollableContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ editor: { commentary } }) => ({
  visible: commentary.visible,
  fetching: commentary.fetching,
  success: commentary.success,
  threads: getFilteredThreads(commentary, { resolved: false }),
});

const mapDispatchToProps = dispatch => ({
  postComment(comment) {
    return dispatch(postComment(comment));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Commentary);
